import React from 'react';

import type { GameEvent, GameState } from '../../types/game';
import { rememberGroupPlayer } from '../../utils/groupPersistence';

type HostTakeoverEvent = Extract<GameEvent, { type: 'HOST_TAKEOVER' }>;

const isHostTakeoverEvent = (event: GameEvent): event is HostTakeoverEvent => event.type === 'HOST_TAKEOVER';

export function useHostTakeoverSync({
  gameState,
  currentClientPlayerId,
  setIsHost,
}: {
  gameState: GameState;
  currentClientPlayerId: string | null;
  setIsHost: (value: boolean) => void;
}) {
  React.useEffect(() => {
    if (gameState.mode === 'REAL') return;
    const events = gameState.events || [];
    let lastHostEvent: HostTakeoverEvent | undefined;
    for (let i = events.length - 1; i >= 0; i--) {
      if (isHostTakeoverEvent(events[i])) { lastHostEvent = events[i] as HostTakeoverEvent; break; }
    }
    if (!lastHostEvent) return;
    const newHostPlayerId = lastHostEvent.payload?.newHostPlayerId;
    if (!newHostPlayerId) return;
    const isNowHost = newHostPlayerId === currentClientPlayerId;
    setIsHost(isNowHost);
    if (gameState.groupToken && currentClientPlayerId) {
      const me = gameState.players.find((p) => p.id === currentClientPlayerId);
      if (me) {
        rememberGroupPlayer(gameState.groupToken, me.id, { isHost: isNowHost });
      }
    }
  }, [gameState.events, gameState.mode, currentClientPlayerId, setIsHost, gameState.groupToken, gameState.players]);
}
